export default {
    input: {
        marginTop: 0,
    },
};
